'use strict';

exports.__esModule = true;
exports.promiseWithTimout = exports.defaultRequest = exports.handleContentType = exports.httpErrors = exports.AUTH_URL_REGEX = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

/**
 * @access private
 */
var httpErrors = exports.httpErrors = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
    var response = _ref2.response,
        _ref2$replay = _ref2.replay,
        replay = _ref2$replay === undefined ? {} : _ref2$replay,
        url = _ref2.url,
        headers = _ref2.headers;
    var request, newAuthHeaders, req, res;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            request = replay.request;

            if (response.ok) {
              _context.next = 25;
              break;
            }

            if (!(response.status === 401 && !AUTH_URL_REGEX.test(url))) {
              _context.next = 24;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return checkAuth(url);

          case 6:
            if (!request) {
              _context.next = 18;
              break;
            }

            newAuthHeaders = (0, _assign2.default)({}, headers, includeAuthHeader());
            req = createRequest({ url: url, request: request, headers: newAuthHeaders });
            _context.next = 11;
            return fetch(url, req);

          case 11:
            res = _context.sent;
            _context.next = 14;
            return httpErrors({ response: res, url: url, headers: headers });

          case 14:
            res = _context.sent;
            _context.next = 17;
            return handleContentType(res, req);

          case 17:
            return _context.abrupt('return', _context.sent);

          case 18:
            return _context.abrupt('return', createErrorResponse(response, request));

          case 21:
            _context.prev = 21;
            _context.t0 = _context['catch'](3);

            createErrorResponse(response, request);

          case 24:
            return _context.abrupt('return', createErrorResponse(response, request));

          case 25:
            return _context.abrupt('return', response);

          case 26:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 21]]);
  }));

  return function httpErrors(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * @access private
 */
var handleContentType = exports.handleContentType = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(response, request) {
    var contentType, responseJSON;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            contentType = response.headers && response.headers.get('Content-Type');

            if (!(contentType && contentType.toLowerCase().includes('json') && !response.bodyUsed)) {
              _context2.next = 15;
              break;
            }

            _context2.prev = 2;
            _context2.next = 5;
            return response.json();

          case 5:
            responseJSON = _context2.sent;

            logNetworkRequest(response, request, (0, _assign2.default)({}, responseJSON));
            return _context2.abrupt('return', normaliseResponse(responseJSON));

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2['catch'](2);
            return _context2.abrupt('return', _promise2.default.reject(new Error(INTERNAL_ERRORS.connectionFailed)));

          case 13:
            _context2.next = 16;
            break;

          case 15:
            return _context2.abrupt('return', _promise2.default.resolve(response));

          case 16:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[2, 10]]);
  }));

  return function handleContentType(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * @access private
 */


var promiseWithTimout = exports.promiseWithTimout = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(request, timeout) {
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return _promise2.default.race([request(), new _promise2.default(function (_resolve, reject) {
              return setTimeout(function () {
                return reject(new Error(INTERNAL_ERRORS.timeout));
              }, timeout);
            })]);

          case 3:
            return _context3.abrupt('return', _context3.sent);

          case 6:
            _context3.prev = 6;
            _context3.t0 = _context3['catch'](0);
            throw _context3.t0;

          case 9:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this, [[0, 6]]);
  }));

  return function promiseWithTimout(_x4, _x5) {
    return _ref5.apply(this, arguments);
  };
}();

exports.createErrorResponse = createErrorResponse;
exports.checkAuth = checkAuth;
exports.urlEncode = urlEncode;
exports.body = body;
exports.normaliseResponse = normaliseResponse;
exports.createRequest = createRequest;
exports.includeAuthHeader = includeAuthHeader;
exports.logNetworkRequest = logNetworkRequest;

var _caseNormaliser = require('../services/case-normaliser');

var _caseNormaliser2 = _interopRequireDefault(_caseNormaliser);

var _auth = require('../auth');

var _auth2 = _interopRequireDefault(_auth);

var _quLog = require('../utils/qu-log');

var _quLog2 = _interopRequireDefault(_quLog);

var _eventManager = require('../event-manager/event-manager');

var _eventManager2 = _interopRequireDefault(_eventManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INTERNAL_ERRORS = {
  timeout: 'TIMEOUT',
  connectionFailed: 'CONNECTION_FAILED'
};

_eventManager2.default.registerEvent('onUnauthenticated');

var snakeNormaliser = new _caseNormaliser2.default(_caseNormaliser2.default.snakeCase);
var camelNormaliser = new _caseNormaliser2.default(_caseNormaliser2.default.camelCase);
var refreshTokenPromise = undefined;

var AUTH_URL_REGEX = exports.AUTH_URL_REGEX = /oauth\/token/;function createErrorResponse(response, request) {
  return handleContentType(response, request).then(function (error) {
    var err = (typeof error === 'undefined' ? 'undefined' : (0, _typeof3.default)(error)) === 'object' ? error : { error: error };

    throw (0, _extends3.default)({}, err, {
      status: response.status
    });
  });
}

function checkAuth(url) {
  if (refreshTokenPromise === undefined) {
    refreshTokenPromise = _auth2.default.refreshToken().then(function () {
      refreshTokenPromise = undefined;
    }).catch(function (error) {
      _eventManager2.default.dispatchEvent('onUnauthenticated', error);
      refreshTokenPromise = undefined;
      throw error;
    });
    return refreshTokenPromise;
  }

  if (AUTH_URL_REGEX.test(url)) {
    return _promise2.default.reject({ status: 401, message: 'Second auth request failed - 401' });
  }

  return refreshTokenPromise;
}function urlEncode(params) {
  var normalisedParams = snakeNormaliser.call(params);
  var keys = (0, _keys2.default)(normalisedParams).filter(function (param) {
    return normalisedParams[param] !== undefined;
  });
  var url = '?';

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      url += key + '=' + normalisedParams[key] + '&';
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return url.slice(0, -1);
}

/**
 * @access private
 */
function body(data) {
  return (0, _stringify2.default)(snakeNormaliser.call(data));
}

/**
 * @access private
 */
function normaliseResponse(data) {
  return camelNormaliser.call(data);
}

/**
 * @access private
 */
var defaultRequest = exports.defaultRequest = { mode: 'cors', redirect: 'follow' };

function createRequest(_ref4) {
  var url = _ref4.url,
      request = _ref4.request,
      headers = _ref4.headers;

  var req = (0, _assign2.default)({}, defaultRequest, request);
  req.headers = headers;
  _quLog2.default.debug('HTTP ' + req.method + ' ' + url);
  return req;
}

/**
 * @access private
 */
function includeAuthHeader() {
  var token = _auth2.default.hasToken();
  return token ? { Authorization: 'Bearer ' + token.auth } : {};
}

function logNetworkRequest(response, request, responseData) {
  if (typeof __DEV__ !== 'undefined' && __DEV__) {
    var req = request.method.toUpperCase() + ' ' + response.url;
    _quLog2.default.log({
      name: 'API RESPONSE',
      preview: req,
      value: {
        request: request,
        response: response,
        responseData: responseData
      }
    });
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/network/utils.js
// module id = 176
// module chunks = 0